var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.0367422 22h-4.1518677v-6.4963695c0-1.5492958-.0262445-3.5421223-2.1572916-3.5421223-2.159916 0-2.4897209 1.6883912-2.4897209 3.4310209v6.6074709h-4.1474937v-13.35928615h3.9804042v1.82661185h.0568629c.5537573-1.05065174 1.9079695-2.1581664 3.9279153-2.1581664 4.2043566 0 4.9811915 2.7661622 4.9811915 6.3642726zm-17.62750416-15.18414837c-1.33409151 0-2.40923804-1.07864579-2.40923804-2.40836322 0-1.32884262 1.07514653-2.40748841 2.40923804-2.40748841 1.3279678 0 2.40661359 1.07864579 2.40661359 2.40748841 0 1.32971743-1.07864579 2.40836322-2.40661359 2.40836322zm2.07680868 15.18414837h-4.1562418v-13.35928615h4.1562418z",
    fill: "#0077b5",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOption);
export default __webpack_public_path__ + "static/media/linkedin-option.d20a714650f295e860ee8bf4340a89de.svg";
export { ForwardRef as ReactComponent };